import React from 'react';
import cls from 'classnames';

import { IconComp } from '../IconComponent';
import { useBreakpoint } from '../../../hooks/useBreakpoint';

export enum BackgroundColor {
  KIWI = 'kiwi',
  CLOUD = 'cloud',
  GRAPE = 'grape',
  LEMON = 'lemon',
  POMELO = 'pomelo',
}

export enum ImagePosition {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  CENTER = 'center',
}

interface ImageTextProps {
  imageSrc: React.ReactType;
  imagePosition: ImagePosition;
  text: string;
  background: BackgroundColor;
}

export const ImgWithParagraphComp: React.FC<ImageTextProps> = ({ imageSrc, imagePosition, text, background }) => {
  const isBiggerThanMobile = useBreakpoint('48em');
  return (
    <section
      className={cls({
        'bg-cloud-800 text-white': imagePosition === ImagePosition.CENTER && background === BackgroundColor.CLOUD,
      })}
    >
      <div
        className={cls({
          'mx-auto px-4 sm:px-8 lg:px-0 lg:mx-96 flex flex-col items-center text-center justify-center gap-5 py-8 border-b border-cloud-700':
            imagePosition === ImagePosition.CENTER && background === BackgroundColor.CLOUD,
        })}
      >
        <IconComp icon={imageSrc} size={isBiggerThanMobile ? 554 : 250} className="items-center" />
        <p className="text-display-sm text-cloud-400">{text}</p>
      </div>
    </section>
  );
};
